/**
 * AI Coach Hero - NEXT.JS VERSION
 * - Handles null customer data safely
 * - Shows login popup when not logged in
 * - Auto-login redirect when logged in
 * - No crashes, no duplicate listeners
 * - Robust post-login return-to-AI-Coach redirect (two-layer approach)
 *
 * NOTE: Sign In / Create Account popup button handlers are intentionally
 * NOT in this file. They are handled in the liquid template to avoid
 * duplicate event listeners and conflicting redirects.
 */

let appState = {
    isLoading: false
};

const environmentConfig = {
    production: {
        baseUrl: "https://coach.theelefit.com"
    }
};

function getConfig() {
    return environmentConfig.production;
}

function showToast(message, type = 'info') {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.style.cssText = `
    background: ${type === 'success' ? '#4caf50' : type === 'error' ? '#f44336' : '#333'};
    color: white;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    animation: fadein 0.5s;
  `;
    toast.textContent = message;
    container.appendChild(toast);

    setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 4000);
}

function getCustomerData() {
    // URL params
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get('email');
    const customerIdParam = urlParams.get('customerId');

    if (emailParam && customerIdParam) {
        return {
            email: decodeURIComponent(emailParam),
            customerId: decodeURIComponent(customerIdParam)
        };
    }

    // Shopify objects
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.email) {
        return {
            email: window.Shopify.customer.email,
            customerId: window.Shopify.customer.id || window.Shopify.customer.customer_id
        };
    }

    if (window.customer && window.customer.email) {
        return {
            email: window.customer.email,
            customerId: window.customer.id || window.customer.customer_id,
            token: window.customer.token
        };
    }

    // Meta tags
    const emailMeta = document.querySelector('meta[name="customer-email"]');
    const idMeta = document.querySelector('meta[name="customer-id"]');
    if (emailMeta && idMeta) {
        return { email: emailMeta.content, customerId: idMeta.content };
    }

    // localStorage
    const storedEmail = localStorage.getItem('shopifyCustomerEmail');
    const storedId = localStorage.getItem('shopifyCustomerId');
    if (storedEmail && storedId) {
        return { email: storedEmail, customerId: storedId };
    }

    return null;
}

async function handleTryNow() {
    const tryNowBtn = document.getElementById('try-now-btn');
    if (!tryNowBtn || appState.isLoading) return;

    appState.isLoading = true;
    tryNowBtn.disabled = true;

    try {
        const customerData = getCustomerData();
        const config = getConfig();

        if (customerData && customerData.token) {
            // Logged in - redirect with SECURE TOKEN transfer
            const redirectUrl = `${config.baseUrl}/auth?token=${encodeURIComponent(customerData.token)}&sessionTransfer=true`;
            showToast("Welcome back! Starting AI Coach...", "success");
            window.location.href = redirectUrl;
        } else if (customerData && customerData.email && customerData.customerId) {
            // Fallback to email + customerId method
            const encodedEmail = encodeURIComponent(customerData.email);
            const encodedId = encodeURIComponent(customerData.customerId);
            const redirectUrl = `${config.baseUrl}/auth?email=${encodedEmail}&customerId=${encodedId}&sessionTransfer=true`;
            showToast("Welcome back! Starting AI Coach...", "success");
            window.location.href = redirectUrl;
        } else {
            // Not logged in - show popup
            const popup = document.getElementById('login-required-popup');
            if (popup) {
                popup.classList.add('open');
            }
        }
    } catch (error) {
        console.error('Try Now error:', error);
        showToast("Something went wrong. Please try again.", "error");
    } finally {
        appState.isLoading = false;
        tryNowBtn.disabled = false;
    }
}

function openDemoModal() {
    const modal = document.getElementById('demo-modal');
    if (modal) modal.classList.add('open');
}

function closeDemoModal() {
    const modal = document.getElementById('demo-modal');
    if (modal) modal.classList.remove('open');
}

// NOTE: No DOMContentLoaded listener here for buttons.
// All button/popup/modal event listeners are handled in the
// liquid template to prevent duplicate handlers and redirect conflicts.
